<template>
  <div :class="className" :style="{height:height,width:width}" />
</template>

<script>
import * as echarts from 'echarts' // echarts theme
import resize from './mixins/resize'
require('echarts/theme/macarons')

export default {
  mixins: [resize],
  props: {
    className: {
      type: String,
      default: 'chart'
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '400px'
    },
    autoResize: {
      type: Boolean,
      default: true
    },
    chartData: {
      type: Object,
      required: true
    },
    chartTitle: {
      type: String,
      default: 'line chart'
    },
    yAxisTitle: {
      type: String,
      default: 'y轴'
    }
  },
  data () {
    return {
      chart: null
    }
  },
  watch: {
    chartData: {
      deep: true,
      handler (val) {
        this.setOptions(val, this.chartTitle, this.yAxisTitle)
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.initChart()
    })
  },
  beforeDestroy () {
    if (!this.chart) {
      return
    }
    this.chart.dispose()
    this.chart = null
  },
  methods: {
    initChart () {
      this.chart = echarts.init(this.$el, 'macarons')
      this.setOptions(this.chartData, this.chartTitle, this.yAxisTitle)
    },
    setOptions (rawData, chartTitle, yAxisTitle) {
      this.chart.setOption(
        {
          title: {
            text: chartTitle,
            left: 'center'
          },
          xAxis: {
            data: rawData.time,
            // splitNumber: 10,
            boundaryGap: false,
            axisTick: {
              show: true // 显示刻度
            }
            /* axisLabel: { //  如果这个字段不设置，echarts会根据屏宽及横坐标数据自动给出间隔
              interval: 0 // 间隔长度，可自定义（如果是时间格式，echarts会自动处理）
            // rotate: 40 // 横坐标上label的倾斜度
            } */
            // boundaryGap: ['0.5', '0']
          },
          grid: {
            left: 30,
            right: 55,
            bottom: 20,
            top: 30,
            containLabel: true
          },
          tooltip: {
            trigger: 'axis',
            axisPointer: {
              type: 'cross'
            },
            padding: [5, 10]
          },
          yAxis: {
            name: yAxisTitle,
            axisTick: {
              show: true
            },
            type: 'value',
            scale: true,
            min: 'dataMin', // 最小值
            max: 'dataMax',
            boundaryGap: ['0.5', '1']
            // min: -1,
            // max: 1
          },
          legend: {
            left: 'right',
            data: rawData.ids
          },
          series: this.initSeriesArray(rawData)
        }, true,
        false)
    },
    initSeriesArray (params) {
      var series = []
      for (let i = 0; i < params.ids.length; i++) {
        series.push({
          name: params.ids[i],
          itemStyle: {
            normal: {
              lineStyle: {
                width: 2
              }
            }
          },
          smooth: false,
          type: 'line',
          data: params.data[i]
          // animationDuration: 2800,
          // animationEasing: 'cubicInOut'
        })
      }
      return series
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LineChart/index.vue